// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__AfyS8","copyright":"Footer_copyright__7Cd5Y","version":"Footer_version__aN8tJ"};